import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000
})

let loadingToast = null
let activeCount = 0

service.interceptors.request.use(
  config => {
    activeCount++
    if (!loadingToast) {
      loadingToast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
    }
    const token = store.getters['user/token']
    config.data = JSON.stringify(config.data)
    config.headers = {
      'Content-Type': 'application/json',
      'x-token': token
    }
    return config
  },
  error => {
    activeCount = 0
    loadingToast && loadingToast.clear()
    loadingToast = null
    Toast.fail('请求异常')
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    activeCount--
    if (activeCount <= 0) {
      activeCount = 0
      loadingToast && loadingToast.clear()
      loadingToast = null
    }
    if (response.config.responseType === 'blob') {
      return response
    }
    if (response.data.code == 0) {
      return response.data
    } else {
      Toast.fail(response.data.msg || '请求失败')
      if (response.data.data && response.data.data.reload) {
        store.commit('user/LoginOut')
      }
      return Promise.reject(response.data.msg)
    }
  },
  error => {
    activeCount = 0
    loadingToast && loadingToast.clear()
    loadingToast = null
    Toast.fail('网络异常')
    return Promise.reject(error)
  }
)

export default service
